import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../AppConfig';
 
@Injectable({
  providedIn: 'root'
})
export class DestacadosService {
 
  headers = new HttpHeaders ({ 'Content-Type' : 'application/json'});
  endpoint: string = '';
 
  /* constructor () {} */
 
  constructor(private http: HttpClient, private appConfig: AppConfig) {
    this.endpoint = this.appConfig.getConfig('base_url');
  }
 
  obtenerMasDestacados(): Observable<any> {
    console.log("obtenerMasDestacados url");
    return this.http.post(`${this.endpoint}/bnt/inmuebles/masDestacados`,{}, { headers: this.headers });
  }
}
 